<div class="discount-card">
    <div class="discount-item" *ngIf="isEnablePoints">
        <ng-container [ngTemplateOutlet]="ALTPAYTYPE" [ngTemplateOutletContext]="{ type: 'POINTS' }">
        </ng-container>
    </div>
    <div class="discount-item" *ngIf="isEnablePromo || isEnableCoupon">
        <ng-container [ngTemplateOutlet]="ALTPAYTYPE" [ngTemplateOutletContext]="{ type: 'PROMOCOUPON' }">
        </ng-container>
    </div>
</div>
<ng-template #ALTPAYTYPE let-type="type">
    <div class="item-container" [ngSwitch]="type">
        <ng-container *ngSwitchCase="'POINTS'">

            <p class="label">
                <ng-container *ngIf="computedDetail?.isPromoApplied">
                    {{ "ALTPAY#SUBTITLE#OPEN#NONUDHEEKPOINTS" | translate }}
                </ng-container>
                <ng-container *ngIf="!computedDetail?.isPromoApplied">
                    {{ "ALTPAY#SUBTITLE#OPEN#NUDHEEKPOINTS" | translate }}
                </ng-container>
            </p>

            <div class="points-button-container" [ngClass]="{'points-disabled-button': (computedDetail?.isPromoApplied || ((computedDetail?.isCouponApplied && computedDetail?.display?.totalAmount == 0 && !computedDetail?.isPointsApplied)))}">

                <button class="alt-btn" (click)="openAltPayments('A')" [disabled]="(computedDetail?.isPromoApplied || (computedDetail?.isCouponApplied && computedDetail?.display?.totalAmount == 0 && !computedDetail?.isPointsApplied) || (isAutoApplyingCoupon || isAutoApplyingPromo))">

                    <img src="./assets/icons/nudheek-icon.svg" class="btn-icon" />

                    <span>
                        <strong *ngIf="computedDetail?.isPointsApplied"> {{ "ALTPAY#BUTTON#APPLIED#NUDHEEKPOINTS" | translate : 'LABELS' : null : null: computedDetail?.coupon_or_discount?.appliedPoints: null: null : null }} </strong>
                        <strong *ngIf="!computedDetail?.isPointsApplied"> {{ "ALTPAY#BUTTON#OPEN#NUDHEEKPOINTS" | translate }} </strong>
                    </span>
                </button>
                <img *ngIf="computedDetail?.isPointsApplied" src="./assets/icons/close_black.svg" class="clear-icon" (click)="$event.stopPropagation(); clearPoints($event)" />
            </div>

        </ng-container>
        <ng-container *ngSwitchCase="'PROMOCOUPON'">

            <p class="label"> {{ "ALTPAY#SUBTITLE#OPEN#PROMOCOUPON" | translate }} </p>

            <button class="alt-btn" (click)="openAltPayments('B')" [disabled]="isAutoApplyingCoupon || isAutoApplyingPromo">
                <img src="./assets/icons/discount.svg" class="btn-icon" />
                <span *ngIf="!isAutoApplyingCoupon && !isAutoApplyingPromo" [ngClass]="{'applied-label': computedDetail?.isCouponApplied || computedDetail?.isPromoApplied}">
                    <strong *ngIf="computedDetail?.isPromoApplied || computedDetail?.isCouponApplied; else APPLY">
                        {{ "ALTPAY#BUTTON#APPLIED#PROMOCOUPON" | translate }}
                    </strong>
                    <ng-template #APPLY>
                        {{ "ALTPAY#BUTTON#OPEN#PROMOCOUPON" | translate }}
                    </ng-template>
                    <img class="applied-promo-coupon" *ngIf="computedDetail?.isPromoApplied || computedDetail?.isCouponApplied" src="./assets/icons/blue_tick.svg" class="suffix-icon" alt="Applied" />
                </span>
                <span *ngIf="isAutoApplyingCoupon">{{ "ALTPAY#AUTOAPPLY#APPLYING#COUPON" | translate }}
                </span>
                <span *ngIf="isAutoApplyingPromo">{{ "ALTPAY#AUTOAPPLY#APPLYING#PROMO" | translate }}</span>
            </button>
        </ng-container>
        <ng-container *ngSwitchDefault>
            Invalid Type
        </ng-container>
    </div>
</ng-template>

<app-consent-modal *ngIf="showConsentModal" (complete)="completeConsent($event)"></app-consent-modal>

<app-alternate-payment-modal
  *ngIf="showCouponModal"
  [type]="couponProps?.types"
  [actualTypes]="couponProps?.actualTypes"
  [title]="couponProps?.title"
  [applyButton]="couponProps?.applyButton"
  [patientPayable]="couponProps?.patientPayable"
  [appliedPoints]="couponProps?.appliedPoints"
  [chargeStr]="couponProps?.chargeStr"
  [parsedChargeInfo]="couponProps?.parsedChargeInfo"
  [discountDetails]="couponProps?.discountDetails"
  [computedDetail]="couponProps?.computedDetail"
  [selections]="couponProps?.selections"
  [apptDetail]="couponProps?.apptDetail"
  [chargeDetails]="couponProps?.chargeDetails"
  [additionalInfo]="couponProps?.additionalInfo"
  [selectedServices]="couponProps?.selectedServices"
  [isDiscountOnApptBooking]="couponProps?.isDiscountOnApptBooking"
  [settings]="couponProps?.settings"
  [parentApplyingCode]="parentApplyingCode"
  [couponAdditionalParams]="couponProps?.couponAdditionalParams"
  [hidden]="couponProps?.additionalInfo?.autoApply"
  (complete)="completeCoupon($event)">
</app-alternate-payment-modal>

<app-alternate-payment-modal
  *ngIf="showPointsModal"
  [type]="pointsProps?.types"
  [actualTypes]="pointsProps?.actualTypes"
  [title]="pointsProps?.title"
  [applyButton]="pointsProps?.applyButton"
  [patientPayable]="pointsProps?.patientPayable"
  [appliedPoints]="pointsProps?.appliedPoints"
  [chargeStr]="pointsProps?.chargeStr"
  [parsedChargeInfo]="pointsProps?.parsedChargeInfo"
  [computedDetail]="pointsProps?.computedDetail"
  [selections]="pointsProps?.selections"
  [hidden]="hiddenPointsUI"
  [apptDetail]="pointsProps?.apptDetail"
  [chargeDetails]="pointsProps?.chargeDetails"
  [additionalInfo]="pointsProps?.additionalInfo"
  [selectedServices]="pointsProps?.selectedServices"
  [isDiscountOnApptBooking]="pointsProps?.isDiscountOnApptBooking"
  [settings]="pointsProps?.settings"
  [parentApplyingCode]="parentApplyingCode"
  (complete)="completePoints($event)">
</app-alternate-payment-modal>


<!-- <div class="consent-backdrop" *ngIf="showConsentModal">
  <div class="consent-modal">
    <div class="consent-header">
      <div class="header-title">
        {{ "NUHDEEKCONSENT#MODAL#HEADER" | translate }}
      </div>
      <button class="close-btn" (click)="closeConsent('CLOSE')">
        <img src="./assets/icons/close_black.svg" alt="close">
      </button>
    </div>
    <div class="consent-body">
      <img class="consent-icon" src="./assets/icon/consent/Nuhdeekicon.svg" alt="">
      <p class="consent-text">
        {{ "NUHDEEKCONSENT#MODAL#SUBHEADER" | translate }}
      </p>
    </div>
    <div class="consent-actions">
      <button class="primary-btn" (click)="closeConsent('CONTINUE')">
        {{ "NUHDEEKCONSENT#MODAL#BTN#AGREE#CONTINUE" | translate }}
      </button>
    </div>
  </div>
</div> -->
